import PharmacyLookupPage from "./PharmacyLookupPage";

export default PharmacyLookupPage;

export * from "./PharmacyLookupPage";
